"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
var IOSIcon = function IOSIcon(props) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], (0, _extends2["default"])({
    className: 'text-light dark:text-ultra-light'
  }, props, {
    viewBox: '0 0 100 100',
    style: {
      fill: 'currentColor'
    }
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0.1",
    fill: "none",
    width: "100",
    height: "100"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M82.9,36.3c-0.5,0.4-9.3,5.4-9.3,16.5c0,12.8,11.3,17.4,11.6,17.5c-0.1,0.3-1.8,6.2-5.9,12.3c-3.7,5.3-7.6,10.6-13.4,10.6  s-7.4-3.4-14.2-3.4c-6.6,0-9,3.5-14.3,3.5s-9.1-4.9-13.4-11c-5-7.1-9-18.1-9-28.6C15,36.9,25.9,28,36.7,28c5.7,0,10.5,3.7,14.1,3.7  c3.4,0,8.7-4,15.2-4C68.2,27.7,77.1,27.9,82.9,36.3z M62.7,20.6c2.7-3.2,4.6-7.6,4.6-12c0-0.6-0.1-1.2-0.2-1.7  c-4.4,0.2-9.6,2.9-12.7,6.5c-2.5,2.8-4.8,7.2-4.8,11.7c0,0.7,0.1,1.3,0.2,1.6c0.3,0.1,0.7,0.1,1.2,0.1  C54.9,26.7,59.9,24.1,62.7,20.6z"
  }));
};
var _default = exports["default"] = IOSIcon;
//# sourceMappingURL=IOSIcon.js.map